import { RadioList } from '@components/OnboardingRadioList'
import styled from 'styled-components'

export const StepSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}rem;
  padding-top: ${({ theme }) => theme.spacing.xs}rem;

  & > p {
    margin: 0;
    font-size: ${({ theme }) => theme.fontSize.md}rem;
    color: ${({ theme }) => theme.colors.metalGray};
  }
`

export const HearAboutRadioList = styled(RadioList)`
  > * {
    padding-inline: 0;
  }
`
